export default __webpack_public_path__ + "static/pro-qr-code-544a19b5478ee709a990c4a4ced03112.png";